import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { PublishedPackListItem } from 'app/typings/core/admin/packs/publishedPackList';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useVoucherPacks() {
  return useQuery({
    queryKey: [CORE_QUERY_KEYS.voucherPacks],
    queryFn: () =>
      apiRequest({
        path: ENDPOINTS.getPublishedPacks,
      }) as Promise<PublishedPackListItem[]>,
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
  });
}
